import { call, delay, put, select, takeEvery, takeLatest } from "redux-saga/effects";
import { mucThuNienCheApi } from "../../../api/category/mucThuNienCheApi";
import { NotifyHelper } from "../../../helpers/toast";
import {
  IDmMucThuNienCheCopyRequest,
  IDmMucThuNienCheViewModelRequest,
  IMucThuNienCheApDungRequest,
  IMucThuNienChePreviewRequest,
} from "../../../model/request/category/dmMucThuNienCheRequest";
import { IDmMucThuNienChe } from "../../../model/respone/category/IDmMucThuNienChe";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import { rootActions } from "../../actions/rootActions";
import {
  eDmMucThuNienCheActionIds,
  IDmMucThuNienCheActionTypes,
} from "../../action-types/category/IDmMucThuNienCheActions";

const mainAction = rootActions.category.mucThuNienChe;

export function* mucThuNienCheSaga(): any {
  yield takeLatest(eDmMucThuNienCheActionIds.LOAD_START, loadWorker);
  yield takeEvery(eDmMucThuNienCheActionIds.SAVE_START, saveWorker);
  yield takeLatest(eDmMucThuNienCheActionIds.LOCK_START, lockWorker);
  yield takeLatest(eDmMucThuNienCheActionIds.UNLOCK_START, unlockWorker);
  yield takeLatest(eDmMucThuNienCheActionIds.COPY_START, copyWorker);
  yield takeLatest(eDmMucThuNienCheActionIds.PREVIEW_START, previewWorker);
  yield takeLatest(eDmMucThuNienCheActionIds.AP_DUNG_START, apDungWorker);
}

function* loadWorker(action: IDmMucThuNienCheActionTypes): any {
  const payload = action.payload as IDmMucThuNienCheViewModelRequest;
  const res: IBaseRespone = yield call(mucThuNienCheApi.Select, payload);
  if (res.is_success) yield put(mainAction.LOAD_SUCCESS(res.data));
  else yield put(mainAction.LOAD_ERRR(res.message ?? "Có lỗi"));
}

function* saveWorker(action: IDmMucThuNienCheActionTypes): any {
  const payload = action.payload as IDmMucThuNienChe[];
  const res = yield call(mucThuNienCheApi.Save, payload);
  if (!res) return;
  if (res.is_success) yield put(mainAction.SAVE_SUCCESS(res.data));
  else yield put(mainAction.SAVE_ERROR(res.message ?? "Có lỗi"));
}

/** Khóa / mở khóa / sao chép xong đều nạp lại danh sách theo bộ lọc hiện tại. */
function* napLaiTheoBoLoc(): any {
  const request = yield select((x: any) => x.category.mucThuNienChe.request);
  if (request?.hoc_ky && request?.nam_hoc) yield put(mainAction.LOAD_START(request));
}

function* lockWorker(action: IDmMucThuNienCheActionTypes): any {
  const payload = action.payload as IDmMucThuNienCheViewModelRequest;
  const res = yield call(mucThuNienCheApi.Lock, payload);
  if (!res) return;
  if (res.is_success) {
    yield put(mainAction.LOCK_SUCCESS(res.data));
    yield call(napLaiTheoBoLoc);
  } else yield put(mainAction.LOCK_ERRR(res.message ?? "Có lỗi"));
}

function* unlockWorker(action: IDmMucThuNienCheActionTypes): any {
  const payload = action.payload as IDmMucThuNienCheViewModelRequest;
  const res = yield call(mucThuNienCheApi.Unlock, payload);
  if (!res) return;
  if (res.is_success) {
    yield put(mainAction.UNLOCK_SUCCESS(res.data));
    yield call(napLaiTheoBoLoc);
  } else yield put(mainAction.UNLOCK_ERRR(res.message ?? "Có lỗi"));
}

function* copyWorker(action: IDmMucThuNienCheActionTypes): any {
  const payload = action.payload as IDmMucThuNienCheCopyRequest;
  const res = yield call(mucThuNienCheApi.Copy, payload);
  if (!res) return;
  if (res.is_success) {
    yield put(mainAction.COPY_SUCCESS(res.data));
    yield call(napLaiTheoBoLoc);
  } else yield put(mainAction.COPY_ERROR(res.message ?? "Có lỗi"));
}

function* previewWorker(action: IDmMucThuNienCheActionTypes): any {
  const payload = action.payload as IMucThuNienChePreviewRequest;
  // Bảng giá niên chế chỉ áp cho sinh viên ĐANG HỌC — phía máy chủ tự chốt, không gửi lên từ đây.
  const res = yield call(mucThuNienCheApi.PreviewApDung, { ids: payload.ids });
  if (!res) return;
  if (res.is_success) {
    const items = res.data ?? [];
    if (items.length === 0) {
      NotifyHelper.Error("Không có sinh viên nào thuộc phạm vi đã thiết lập");
      yield put(mainAction.PREVIEW_ERROR("Không có sinh viên nào thuộc phạm vi đã thiết lập"));
      return;
    }
    yield put(mainAction.PREVIEW_SUCCESS(items));
  } else {
    NotifyHelper.Error(res.message ?? "Tính trước thất bại");
    yield put(mainAction.PREVIEW_ERROR(res.message ?? "Có lỗi"));
  }
}

function* apDungWorker(action: IDmMucThuNienCheActionTypes): any {
  const payload = action.payload as IMucThuNienCheApDungRequest;
  // Lượt có duyệt sẽ báo tiến trình qua hub: chờ bảng tiến trình kịp hiện và đăng ký nghe,
  // nếu không chạy nhanh quá là lỡ mất mấy bước đầu, người dùng nhìn thanh chạy đứng im.
  if (payload.is_duyet && payload.process_id) yield delay(150);
  const res = yield call(mucThuNienCheApi.ApDung, payload);
  if (!res) return;
  if (res.is_success) {
    const kq = res.data ?? {};
    NotifyHelper.Success(
      `Đã áp dụng: thêm mới ${kq.so_sv_them_moi ?? 0}, cập nhật ${
        kq.so_sv_cap_nhat ?? 0
      }, bỏ qua ${kq.so_sv_bo_qua ?? 0}`,
    );
    yield put(mainAction.AP_DUNG_SUCCESS(kq));
  } else yield put(mainAction.AP_DUNG_ERROR(res.message ?? "Có lỗi"));
}
